import styled from "styled-components";
import { breakpoints } from "../helpers/breakpoints";

export const WheelStyled = styled.div`
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    .container{
        width: calc(100% - 30px);
        margin-bottom: 15px;
        margin-top: 15px;
        background-color: #FFFFFF;
        padding: 25px 25px;
        border-radius: 12px;
        box-shadow: 4px 0px 23px 0px rgba(0,0,0,0.25);
        -webkit-box-shadow: 4px 0px 23px 0px rgba(0,0,0,0.25);
        -moz-box-shadow: 4px 0px 23px 0px rgba(0,0,0,0.25);
    }

    @media ${breakpoints.xs} {//576px
    }
    @media ${breakpoints.sm} {//768px
        align-items: center;
        .container{
            width: 700px;
            margin-bottom: 0;
            margin-top: 0;
        }
    }
    @media ${breakpoints.md} {//992px
    }
    @media ${breakpoints.lg} {//1200px // Desktop
    }
    @media ${breakpoints.xl} {//1366px
    }
    @media ${breakpoints.xxl} {//1440px
    }
    @media ${breakpoints.xxxl} {//1680px
    }
    @media ${breakpoints.xxxxl} {//1920px
    }
`